export default __webpack_public_path__ + "static/media/illustration.bdf1c60c.svg";